import type { Country } from "./country/Country"

export type DateFormat =
	| "dd.MM.yyyy"
	| "dd-MM-yyyy"
	| "dd/MM/yyyy"
	| "yyyy.MM.dd"
	| "yyyy-MM-dd"
	| "yyyy/MM/dd"
	| "MM.dd.yyyy"
	| "MM-dd-yyyy"
	| "MM/dd/yyyy"

/** Single source of truth for the date format conventionally used per country */
export const countryDateFormats: Record<Country, DateFormat> = {
	AE: "dd/MM/yyyy",
	AM: "dd/MM/yyyy",
	AR: "dd/MM/yyyy",
	AT: "dd.MM.yyyy",
	AU: "dd/MM/yyyy",
	AZ: "dd/MM/yyyy",
	BA: "dd.MM.yyyy",
	BE: "dd.MM.yyyy",
	BG: "dd.MM.yyyy",
	BH: "dd/MM/yyyy",
	BN: "dd.MM.yyyy",
	BO: "dd-MM-yyyy",
	BR: "dd/MM/yyyy",
	CA: "MM.dd.yyyy",
	CH: "dd.MM.yyyy",
	CL: "dd-MM-yyyy",
	CN: "dd.MM.yyyy",
	CO: "dd/MM/yyyy",
	CR: "dd/MM/yyyy",
	CW: "dd-MM-yyyy",
	CY: "dd/MM/yyyy",
	CZ: "dd.MM.yyyy",
	DE: "dd.MM.yyyy",
	DK: "dd-MM-yyyy",
	DO: "dd.MM.yyyy",
	DU: "dd.MM.yyyy",
	EC: "dd/MM/yyyy",
	EE: "dd.MM.yyyy",
	EG: "dd/MM/yyyy",
	ES: "dd/MM/yyyy",
	FI: "dd.MM.yyyy",
	FR: "dd/MM/yyyy",
	GB: "dd/MM/yyyy",
	GE: "dd/MM/yyyy",
	GP: "dd.MM.yyyy",
	GR: "dd/MM/yyyy",
	GT: "dd/MM/yyyy",
	HK: "dd.MM.yyyy",
	HN: "dd/MM/yyyy",
	HR: "dd.MM.yyyy",
	HU: "yyyy.MM.dd",
	ID: "dd/MM/yyyy",
	IE: "dd/MM/yyyy",
	IL: "dd/MM/yyyy",
	IN: "dd-MM-yyyy",
	IS: "dd.MM.yyyy",
	IT: "dd/MM/yyyy",
	JM: "dd/MM/yyyy",
	JO: "dd/MM/yyyy",
	JP: "yyyy/MM/dd",
	KH: "dd/MM/yyyy",
	KR: "yyyy.MM.dd",
	KW: "dd/MM/yyyy",
	KZ: "dd/MM/yyyy",
	LB: "dd/MM/yyyy",
	LK: "yyyy-MM-dd",
	LT: "yyyy.MM.dd",
	LU: "dd/MM/yyyy",
	LV: "dd.MM.yyyy",
	MA: "dd/MM/yyyy",
	MC: "dd/MM/yyyy",
	MD: "dd.MM.yyyy",
	MK: "dd.MM.yyyy",
	MN: "dd.MM.yyyy",
	MT: "dd/MM/yyyy",
	MU: "dd/MM/yyyy",
	MX: "dd/MM/yyyy",
	MY: "dd/MM/yyyy",
	NC: "dd.MM.yyyy",
	NL: "dd.MM.yyyy",
	NO: "dd.MM.yyyy",
	NZ: "dd/MM/yyyy",
	OM: "dd/MM/yyyy",
	PA: "MM/dd/yyyy",
	PE: "dd/MM/yyyy",
	PF: "dd.MM.yyyy",
	PH: "MM/dd/yyyy",
	PL: "dd.MM.yyyy",
	PR: "MM-dd-yyyy",
	PT: "dd-MM-yyyy",
	PY: "dd/MM/yyyy",
	QA: "dd/MM/yyyy",
	RE: "dd/MM/yyyy",
	RO: "dd.MM.yyyy",
	RS: "dd.MM.yyyy",
	SA: "dd/MM/yyyy",
	SG: "dd/MM/yyyy",
	SI: "dd.MM.yyyy",
	SK: "dd.MM.yyyy",
	SV: "dd.MM.yyyy",
	TH: "dd.MM.yyyy",
	TN: "dd/MM/yyyy",
	TR: "dd.MM.yyyy",
	TT: "dd/MM/yyyy",
	TW: "yyyy/MM/dd",
	UA: "dd.MM.yyyy",
	US: "MM/dd/yyyy",
	UY: "dd/MM/yyyy",
	UZ: "dd/MM/yyyy",
	VN: "dd/MM/yyyy",
	XA: "dd/MM/yyyy",
	XD: "dd.MM.yyyy",
	XP: "dd.MM.yyyy",
	ZA: "yyyy/MM/dd",
}
